import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ExternalLink } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300 py-16 px-6" data-testid="main-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_baja-laboral-riesgos/artifacts/m7tg5pgh_logo.jpg" 
                alt="PrevenciónLegal @tecnoabogado" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-slate-400 max-w-md">
              Especialistas en Derecho del Trabajo y Prevención de Riesgos Laborales. 
              La técnica preventiva ya no es suficiente. La prevención también se asesora.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <Mail size={16} className="text-slate-500" />
              <a href="/#contacto" className="text-sm hover:text-white transition">
                Formulario de contacto
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4">
              Navegación
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#analizador" className="footer-link text-sm">
                  Analizador de riesgos
                </a>
              </li>
              <li>
                <Link to="/faq" className="footer-link text-sm">
                  Preguntas frecuentes
                </Link>
              </li>
              <li>
                <a href="#blog" className="footer-link text-sm">
                  Blog y artículos
                </a>
              </li>
              <li>
                <a href="#recursos" className="footer-link text-sm">
                  Recursos descargables
                </a>
              </li>
              <li>
                <a href="#contacto" className="footer-link text-sm">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* External Sites */}
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4">
              Nuestras webs
            </h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://www.tecnoabogado.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link text-sm flex items-center gap-1"
                >
                  tecnoabogado.com
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a 
                  href="https://www.vilaplanaabogados.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link text-sm flex items-center gap-1"
                >
                  vilaplanaabogados.com
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a 
                  href="https://www.despido.net" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link text-sm flex items-center gap-1"
                >
                  despido.net
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a 
                  href="https://www.iabogacia.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link text-sm flex items-center gap-1"
                >
                  iabogacia.com
                  <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a 
                  href="https://www.jurisciberia.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link text-sm flex items-center gap-1"
                >
                  jurisciberia.com
                  <ExternalLink size={12} />
                </a>
              </li>
            </ul>

            {/* Legal Links */}
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-4 mt-8">
              Avisos legales
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/privacidad" className="footer-link text-sm">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" className="footer-link text-sm">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <Link to="/legal/aviso-legal" className="footer-link text-sm">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link to="/legal/transparencia-ia" className="footer-link text-sm">
                  Transparencia IA (EU AI Act)
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-slate-500">
              © {currentYear} vilaplana@tecnoabogado. Todos los derechos reservados.
            </p>
            <p className="text-xs text-slate-500">
              Marco normativo actualizado (Marzo 2026)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
